const ActionType = Object.freeze({
    Unknown: 0,
    Recommended: 1,
    Clicked: 2,
    AddedToCart: 3,
    Purchased: 4,
  });

  export default ActionType;